module.exports = __webpack_public_path__ + "img/67.8.TSS.d8e4c586.png";